import React, { useEffect, useRef, useState } from 'react';

export default function Reveal({ children, delay = 0, className = '', as: As = 'div' }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { setTimeout(() => setShown(true), delay); io.disconnect(); }
      });
    }, { threshold: 0.12 });
    io.observe(el); return () => io.disconnect();
  }, [delay]);
  return <As ref={ref} className={`reveal ${shown ? 'in' : ''} ${className}`}>{children}</As>;
}
